/**
 * Beta environment
 */
export const environment = {
    production: true,
    URL_API: "https://betaapi2.gesthispania.es/payyourfines/",
    URL_API_TINY: "https://betaapi2.gesthispania.es/pyf/"
};
